import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../../../services/report.service';
import { UserService } from '../../../services/user.service';
import { ToasterService } from '../../../services/toaster.service';
import { IReport } from '../../../interfaces/reports';
import { CostCenterService } from '../../../services/cost-center.service';
import { ICostCenter } from '../../../interfaces/cost-center';

@Component({
  selector: 'company-report',
  styleUrls: ['../reports.component.scss'],
  templateUrl: './company-report.component.html',
  providers: [CostCenterService]
})
export class CompanyReportComponent implements OnInit {

  currentView = 'general-view';
  loading = true;
  reports: IReport[];
  groups: ICostCenter[];
  selectedGroups: string | string[] = 'all';
  placesMetrics: any[] = [];

  constructor(
    private reportsService: ReportsService,
    private userService: UserService,
    private toasterService: ToasterService,
    private costCenterService: CostCenterService
  ) {}

  ngOnInit() {
    this.getCostCenters();
    this.getReports();
  }

  getReports() {
    const activeAccount = this.userService.getLoggedAccount();

    this.reportsService.getCompanyReports(activeAccount.id).then((result) => {
      this.loading = false;
      this.sortReport(result.data);
      this.reports = result.data.slice(0, 12);
      this.getPlacesMetrics(this.reports[0].month, this.reports[0].year);
    }, () => {
      this.loading = false;
      this.toasterService.info('Ops!', 'Não conseguimos consultar os dados do relatório. Por favor, tente novamente.', false, 8000);
    });
  }

  getPlacesMetrics(month, year) {
    this.reportsService.getPlacesMetrics(month, year).then(result => {
      this.placesMetrics = result;
    }, () => {
      this.loading = false;
      this.toasterService.info('Ops!', 'Ocorreu um erro ao recuperar alguns dados do relatório. Por favor, tente novamente.', false, 8000);
    });
  }

  getCostCenters() {
    console.log('company-report.component', 'cost centers load');
    const { id } = this.userService.getLoggedAccount();

    const params = [
      { param: 'companyId', value: id, },
      { param: 'limit', value: 1000 }
    ];

    this.costCenterService.getCostCenters(params).then(result => {
      this.groups = result.data.reverse();
    }, () => {
      this.loading = false;
      this.toasterService.info('Ops!', 'Ocorreu um erro ao recuperar alguns dados do relatório. Por favor, tente novamente.', false, 8000);
    });
  }

  sortReport(reports) {
    reports.sort((a, b) => {
      const c: any = new Date(a.date);
      const d: any = new Date(b.date);
      return d - c;
    });
  }

  onSelectGroup(group: string | string[]) {
    this.selectedGroups = typeof group === 'string' ? group : [...group];
  }
}
